import { Link } from "@tanstack/react-router";
import { useT } from "@/i18n";

export function NotFound() {
  const { t } = useT();
  return (
    <section className="px-pad-x py-pad-y">
      <h1 className="text-fs6 font-semibold text-ink-1">{t("state.notFound.title")}</h1>
      <Link to="/" className="mt-s3 inline-block text-fs3 text-brand-ink underline underline-offset-4">
        {t("state.notFound.action")}
      </Link>
    </section>
  );
}
